export default [
  {
    path: "/he/index",
    component: () => import('../page/he/index')
  },
  {
    path: "/he/search",
    component: () => import('../page/he/search')
  },
  {
    path: "/he/list",
    component: () => import('../page/he/list')
  },
  {
    path: "/he/detail",
    component: () => import('../page/he/detail')
  },
]



// WEBPACK FOOTER //
// ./src/router/he.js